import { api, ApiRes } from './client'
import { BankAccountStatus } from '../../typings'

interface PutBankAccountUpdateBody {
    is_main: boolean
}

export interface FrontendBankAccountResource {
    id: string
    holder: string
    iban: string
    status: BankAccountStatus
    is_main: string
    created_at: string
}

export const getBankAccountsForNaturalProfile = (naturalProfileUid): ApiRes<FrontendBankAccountResource[]> =>
    api.get(`natural-profiles/${naturalProfileUid}/bank-accounts`)

export const getBankAccountsForLegalProfile = (legalProfileUid): ApiRes<FrontendBankAccountResource[]> =>
    api.get(`legal-profiles/${legalProfileUid}/bank-accounts`)

export const putBankAccountUpdate = (
    bankAccountUid: string,
    body: PutBankAccountUpdateBody
): ApiRes<FrontendBankAccountResource> => api.put(`bank-accounts/${bankAccountUid}`, body)
